import * as React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { Icon } from '@front10/base-elements';
import { Alert as BaseAlert, Text } from '@theme-ui/components';
import { useTranslation } from '@front10/utils';
import { StyledProps } from '@front10';
import { BaseBoxProps } from '../elements/_commons/BaseBox';

interface AlertProps extends StyledProps<BaseBoxProps> {
  icon?: string;
  iconLabelKey?: string;
  labelKey?: string;
}

const Alert = (props: AlertProps) => {
  const { direction, theme } = React.useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const translate = useTranslation();

  return (
    <BaseAlert className={className} style={style}>
      <Icon
        role="img"
        aria-label={translate(props.iconLabelKey ?? 'cmp-icon-legend-label', 'Information')}
        icon={props.icon ?? 'info'}
        sx={{ mr: '4px', width: '20px', height: '20px' }}
      ></Icon>
      <Text
        sx={{
          'cmp-styles': {
            '@theme': 'eds.typo.fontSize5'
          }
        }}
        dangerouslySetInnerHTML={{
          __html: translate(props.labelKey ?? 'cmp-legend')
        }}
      ></Text>
    </BaseAlert>
  );
};

export default Alert;
